<div class="py-[30px] px-[50px]">
  <div>
    <img class="w-[53px] h-[53px]" src="https://oss.image.xiaogetech.com/OSH1683887470542.png" alt="" />
    <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
    <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
  </div>

  <ng-container *ngIf="step === 1">
    <div class="text-l font-bold text-center mt-[30px] md:text-left">
      {{ "与小红书直连" | translate }}
    </div>

    <div class="text-m mt-[30px]">
      {{ "百居易是小红书的官方直连合作伙伴，在直连之前，您需要了解以下事项：" | translate }}
    </div>

    <div class="text-m mt-[30px]">
      <ol>
        <li>1. <span class="font-bold">请先确认您拥有民宿特种行业许可证，</span>若没有则需要向相关部门申请。</li>
        <li>2. 下载小红书App，并注册一个小红书账号。</li>
        <li>
          3. 请使用电脑浏览器打开
          <a href="https://pro.xiaohongshu.com/" target="_blank">https://pro.xiaohongshu.com/</a>
          小红书专业号平台，使用您的小红书账号登录，按照提示填写并提交相关信息，将您的账号认证为小红书专业号。请注意，<span
            class="font-bold"
            >认证时必须选择人脸识别认证，</span
          >且此过程需要向小红书支付600元/年的认证费用。
        </li>
        <li>
          4. 您在小红书中产生的交易，会被小红书收取3%的佣金，被微信收取0.6%的手续费；<span class="font-bold"
            >百居易不收取任何佣金。</span
          >
        </li>
        <li>
          5. 专业号认证通过后，您需要前往本地生活商家管理平台认领门店，并绑卡。具体操作步骤请查看
          <a href="https://www.myhostex.com/help/?p=137" target="_blank">https://www.myhostex.com/help/?p=137</a>
        </li>
      </ol>
    </div>

    <div class="text-m mt-[30px]">
      <div>如果在此流程中遇到问题，您可以联系小红书客服：</div>
      <ol>
        <li>1. App端登入账号 → 进入页面【我】→左上角“三”形标识，找到客服入口；</li>
        <li>2. Web电脑端登入账号，页面右上角，找到客服入口。</li>
      </ol>
    </div>

    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onFinish()">
        {{ "我已创建好门店，联系客服" | translate }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 2">
    <div class="text-l font-bold text-center mt-[30px] md:text-left">
      {{ "授权百居易访问您的店铺" | translate }}
    </div>

    <div class="text-m mt-[30px]">
      {{
        "请您打开小红书App，使用您认证为专业号的账号登录，进入”我的“页面，点击左上角的“三”，选择“扫码”并扫描下方的二维码。然后根据指示操作，操作完成后联系百居易客服。"
          | translate
      }}
    </div>

    <div class="text-m mt-[30px]">
      <!-- <img src="/assets/status/placeholder.png" alt="" class="w-[100px] h-[100px]" /> -->
      <nz-spin class="w-[100px]" [nzSpinning]="qrLoading">
        <img
          src="/api/thirdparty/xiaohongshu_qrcode"
          alt=""
          class="w-[100px] h-[100px]"
          (load)="qrLoading = false"
          (error)="qrLoading = false" />
      </nz-spin>
    </div>

    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="step = 1">
        {{ "上一步" | translate }}
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onFinish()">
        {{ "已扫码，联系客服" | translate }}
      </button>
    </div>
  </ng-container>
</div>
